/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Provider_Onedrive_LabelInputs */



/**
* | output |
* | --- |
* | "Microsoft OneDrive" |
*
* @param {Spaces_Provider_Onedrive_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_provider_onedrive_label = /** @type {((inputs?: Spaces_Provider_Onedrive_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Provider_Onedrive_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Microsoft OneDrive")
	return /** @type {LocalizedString} */ ("Microsoft OneDrive")
});